import { defineStore } from 'pinia';

import { getSeoInfo, getSeoInfoAttractions, type GetSeoInfoData } from '@/shared/api/experience';
import { useLogger } from '@/shared/utils/logger';

import type { Seo } from './models';
import { normalizeSeo } from './transforms';

export type SeoType = GetSeoInfoData['path']['type'];

export const useSeoEntity = defineStore('journal:seo-entity', {
  state: () => ({
    /**
     * Флаг индикации загрузки.
     */
    isLoading: false,

    /**
     * Флаг, показывающий, что загрузка окончилать неудачей.
     */
    isLoadingFailed: false,

    /**
     * SEO-данные.
     */
    seoState: null as Seo | null,
  }),

  getters: {
    /**
     * Флаг индикации загрузки.
     */
    loading: (state) => state.isLoading,

    /**
     * Флаг, показывающий, что загрузка окончилать неудачей.
     */
    loadingFailed: (state) => state.isLoadingFailed,

    /**
     * SEO-данные.
     */
    seo: (state) => state.seoState,
  },

  actions: {
    logger: useLogger,

    async loadSeo(slug: string, type: SeoType) {
      this.isLoading = true;
      this.isLoadingFailed = false;

      let response;

      try {
        response = await getSeoInfo({ path: { type }, query: { ids: slug } });
      } catch (e) {
        this.logger().log('could not load a city seo by the reason:', e);
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      if (!response.data?.seo) {
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      this.seoState = normalizeSeo(response.data.seo);
      this.isLoading = false;
    },

    async loadSeoAttraction(slug: string, type: SeoType) {
      this.isLoading = true;
      this.isLoadingFailed = false;

      let response;

      try {
        response = await getSeoInfoAttractions({ path: { type }, query: { ids: slug } });
      } catch (e) {
        this.logger().log('could not load a city seo by the reason:', e);
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      if (!response.data?.seo) {
        this.isLoadingFailed = true;
        this.isLoading = false;

        return;
      }

      this.seoState = normalizeSeo(response.data.seo);
      this.isLoading = false;
    },

    /**
     * Сбрасывает состояние экземпляра сущности.
     */
    reset() {
      this.isLoading = false;
      this.isLoadingFailed = false;
      this.seoState = null;
    },
  },
});
